module.exports = __webpack_public_path__ + "img/logo.91f07211.png";